const isProduction = import.meta.env.PROD

export const environment = {
  production: isProduction,
  AWS_REGION: import.meta.env.VITE_AWS_REGION || 'ap-southeast-2',
  COGNITO_IDENTITY_POOL_ID: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || 'ap-southeast-2:79dea377-bf78-40dc-bf31-a8f172c6a0c4',
  COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'ap-southeast-2_vCZ4MMroK',
  COGNITO_USER_POOL_WEB_CLIENT_ID: import.meta.env.VITE_COGNITO_USER_POOL_WEB_CLIENT_ID || '4b16p8aofmauf3hq0q46nbvu83',
  GRPC_SERVER_HOSTNAME: isProduction
    ? (import.meta.env.VITE_GRPC_HOSTNAME || window.location.hostname)
    : (import.meta.env.VITE_GRPC_HOSTNAME || 'kss-test.streamline.enterprises'),
  GRPC_URL: import.meta.env.VITE_GRPC_URL || null,
}
